function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M3.54103 8.00049L12.4528 8.00049",
    stroke: "#99ABA7",
    style: {
      stroke: "#99ABA7",
      stroke: "color(display-p3 0.6000 0.6706 0.6549)",
      strokeOpacity: 1
    },
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.9969 3.54248L12.4528 7.99834L7.99689 12.4542",
    stroke: "#99ABA7",
    style: {
      stroke: "#99ABA7",
      stroke: "color(display-p3 0.6000 0.6706 0.6549)",
      strokeOpacity: 1
    },
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrowRight.7421211a3fa97d56f6e20feeb49790f0.svg";
export { ForwardRef as ReactComponent };